/**
 *  Place for GDrive related functions
 */

import { timber_debug, timber_error } from "../Timber"

const GDRIVE_BASE_URL = "https://www.googleapis.com/drive/v3/files"

const getGDriveReqHeader = (accessToken: string) => {
  return {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }
}

export const getFileIdByName = async (
  accessToken: string,
  folderId: string,
  fileName: string
) => {
  timber_debug(`folderId ${folderId}`)
  timber_debug(`fileName ${fileName}`)
  const query = encodeURIComponent(
    `name = '${fileName}' and '${folderId}' in parents and trashed = false`
  )

  const response = await fetch(
    `${GDRIVE_BASE_URL}?q=${query}&fields=files(id,name)`,
    getGDriveReqHeader(accessToken)
  )

  const data = await response.json()

  if (data.files.length && data.files.length > 0) {
    return data.files[0].id
  } else {
    timber_error("File not found")
    return ""
  }
}

export const getFolderIdByName = async (
  accessToken: string,
  folderName: string
): Promise<string> => {
  timber_debug(`folderName ${folderName}`)
  const query = encodeURIComponent(
    `name='${folderName}' and mimeType='application/vnd.google-apps.folder' and trashed=false`
  )

  const response = await fetch(
    `${GDRIVE_BASE_URL}?q=${query}&fields=files(id,name)`,
    getGDriveReqHeader(accessToken)
  )

  if (!response.ok) {
    if (response.status === 401) {
      timber_error("Token expired")
    }
    return ""
  }

  const data = await response.json()

  if (data.files.length && data.files.length > 0) {
    return data.files[0].id
  } else {
    timber_error("Folder not found")
    return ""
  }
}

/**
 * Get image blob file URL to download from GDrive
 *
 * @param accessToken
 * @param fileId Image file GDrive ID
 * @returns
 */
export const getImageBlobUrl = async (
  accessToken: string,
  fileId: string
): Promise<string> => {
  timber_debug(`fileId ${fileId}`)
  const res = await fetch(
    `${GDRIVE_BASE_URL}/${fileId}?alt=media`,
    getGDriveReqHeader(accessToken)
  )

  if (res.ok) {
    const blob = await res.blob()
    return URL.createObjectURL(blob)
  } else {
    timber_error("Failed to fetch image")
    return ""
  }
}
